module.exports = __webpack_public_path__ + "static/media/BoyNeonXRosa_GraceBeck-8.5087f233.JPG";